export function isInsightRequestFresh({
    requestToken,
    currentToken,
    requestedInsightKey,
    currentInsightKey,
}) {
    return (
        requestToken === currentToken &&
        requestedInsightKey === currentInsightKey
    )
}
